<template>
  <div>
    <div class="left-title">
      Hi! {{ user_info.name }}
      <div class="show-side-menu" @click="showSideMenu(false)">
        <i class="fa-solid fa-bars"></i>
      </div>
    </div>
    <div class="function-bag">
      <div class="power-overview" @click="pickFunction('power-overview')"
        :class="{ 'selected': picked_function === 'power-overview' }">
        <img :src="base_url + '/images/icons/9.png'" alt="">
        用電總覽
      </div>
      <div class="bill-query" @click="pickFunction('bill-query')"
        :class="{ 'selected': picked_function === 'bill-query' }">
        <img :src="base_url + '/images/icons/11.png'" alt="">
        電費查詢
      </div>
    </div>
    <div class="left-footer">
      <div @click="openModal" class="logout-btn">
        <i class="fa-solid fa-gear"></i> Setting
      </div>
      <div @click="userLogout" class="logout-btn">
        <i class="fa-solid fa-power-off"></i> Logout
      </div>
    </div>

    <user-setting />
  </div>
</template>

<script>
import UserSetting from '../modal/UserSetting.vue';

export default {
  data() {
    return {
      base_url: base_url,
    }
  },
  computed: {
    user_info() {
      return JSON.parse(localStorage.getItem('user_info'));
    },
    picked_function() {
      return this.$store.getters.pickedFunction;
    },
  },
  methods: {
    pickFunction(function_name) {
      console.log('--ex-home-- function switch');
      this.$store.commit('setPickedFunction', function_name);
      this.showSideMenu();
    },
    openModal() {
      const modal = this.$el.querySelector('#setting-modal');
      const blur_bg = this.$el.querySelector('.blur-bg');
      modal.style.display = 'block';
      modal.classList.add('show');
      blur_bg.style.display = 'block';
      modal.addEventListener('click', (e) => {
        if (e.target.id === 'setting-modal') {
          this.closeModal();
        }
      });
    },
    closeModal() {
      const modal = this.$el.querySelector('#setting-modal');
      const blur_bg = this.$el.querySelector('.blur-bg');
      modal.style.display = 'none';
      modal.classList.remove('show');
      blur_bg.style.display = 'none';
    },
    userLogout() {
      axios.get(base_url + "/api/logout")
        .then((response) => {
          localStorage.removeItem('token');
          localStorage.removeItem('user_info');
          this.$store.commit('setLoginCurrentContent', 'login');
          this.$router.push({ name: "login" });
        }).catch(error => this.axiosMessage(error));
    },
    showSideMenu() {
      this.$emit("show-side-menu");
    }
  },
  components: {
    UserSetting,
  }
}
</script>

<style scoped>
a {
  color: var(--bx-blur);
  text-decoration: none;
}

.left-title {
  padding: 6vh 0 0 0;
  font-weight: bolder;
  color: white;
  font-size: 1.25rem;
  width: 100%;
  flex-grow: 1;
}

.function-bag {
  padding: 1rem 0;
  border-bottom: 1px solid var(--bx-blur);
  width: 100%;
  flex-grow: 20;
}

.function-bag>div {
  display: flex;
  align-items: center;
  cursor: pointer;
  width: 100%;
  height: 3rem;
  padding-left: 8%;
}

.function-bag>div img {
  margin-right: 1rem;
  width: 1.5rem;
  height: 1.5rem;
}

.function-bag .selected {
  background-color: var(--bx-light-focus-bg);
  border-radius: 5px;
  border-left: 5px solid white;
  color: white;
}

.function-bag .selected>img {
  margin-right: calc(1rem - 5px);
}

.left-footer {
  margin-top: 2vh;
  width: 100%;
  flex-grow: 2;
}

.left-footer>div {
  font-weight: bold;
  font-size: 1rem;
  cursor: pointer;
  margin-bottom: 1rem;
}

.left-footer>div:hover {
  color: white;
}

@media all and (orientation:landscape) {

  .left-title .show-side-menu {
    display: none;
  }
}

@media all and (orientation:portrait) {

  .left-title {
    padding: 2vh 0 0 1rem;
    font-size: 1.5rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-grow: 1;
  }

  .left-title .show-side-menu {
    display: block;
    cursor: pointer;
    font-size: 1.5rem;
    width: 7vh;
    line-height: 3.5rem;
    color: var(--bx-unselected-btn);
    text-align: right;
  }
}
</style>
